// --------------------------------------------------------------
// Created On: 2025-04-02
// Author: Hannah Vaughan
//
// Last Modified: 2026-07-29
// Modified By: Jonathon Hicke
//
// Copyright 2025 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./RemoteLockControls.module.scss";
import PanelSection from "../PanelSection/PanelSection";
import { BREAKPOINT_SMALL } from "src/constants/breakpoints";

// Container for the Remote Lock controls section in the Remote Operation Panel.
export default function RemoteLockControls(props: Props): Component {
  return (
    <PanelSection label="Remote Lock">
      <div className={`col px-3 ${styles.controlColumn}`}>
        {!props.isLockedOut && (
          <button
            data-test="remote-operations-lock-remote-control-button"
            className="btn btn-danger w-100"
            type="button"
            disabled={props.disabled}
            onClick={() => props.onChangeLock(true)}
          >
            {props.windowDimensionWidth > BREAKPOINT_SMALL ? "Lock Remote Control" : "Lock"}
          </button>
        )}
      </div>
    </PanelSection>
  );
}

interface Props {
  isLockedOut: boolean;
  disabled: boolean;
  windowDimensionWidth: number;
  onChangeLock: (isLocked: boolean) => void;
}
